(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('InImageCommonService', [
        '$http',
        '$q',
        function($http, $q) {
            this.replaceCommonPlaceholders = function(scope, template, options) {
                template = template.replace('[user_closeActionTime]', options.closeActionTime);
                template = template.replace('[user_maxWidth]', options.maxWidth);
                template = template.replace('[user_creativeWidth]', options.creativeWidth);
                template = template.replace('[user_creativeHeight]', options.creativeHeight);
                return template;
            };
        },
    ]);
})(window.angular);
